import { DropdownOption } from '../../../Dropdown';
import { DropdownFieldItem } from './types';

export const mapItemsToOptionsFormat = (
  items: DropdownFieldItem[]
): DropdownOption[] => {
  return items
    .map((item) => {
      return {
        id: item.key,
        value: item.key,
        label: item.displayName,
      };
    })
    .sort((a, b) => {
      if (typeof a.label === 'string' && typeof b.label === 'string') {
        return a.label.localeCompare(b.label);
      }
      return 0;
    });
};
